
class CapViewStudentSearch {
  constructor(config) {
    this.config = config
  }

  // eslint-disable-next-line
  checkPermission(options = {}) {
    return Boolean(this.config)
  }
}

function key() {
  return 'view_student_search'
}

function create(config) {
  return new CapViewStudentSearch(config)
}

export default {
  key,
  create,
}
